import React from 'react';
import Typography from '@mui/material/Typography';

export type JucyLightBoxCaptionProps = { caption?: string };
export const JucyLightBoxCaption = ({ caption }: JucyLightBoxCaptionProps) => {
    return caption ? (
        <Typography
            sx={{
                typography: 'body1',
                color: 'text.primary',
                textAlign: 'center',
                userSelect: 'none',
            }}
        >
            {caption}
        </Typography>
    ) : null;
};
